import { Box, CardActionArea, Stack, Typography } from "@mui/material";
import { selectableOptionSx } from "@zfp-akademie-a-s/zfp-design";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC, ReactNode } from "react";

// Every card that opens on a click (a goal, an asset, a family member, a contract) and the portfolio cards: the
// package's selectable box, grey under the pointer, with a grey border in SelectableOption's 8px radius
export const tileSx = { ...selectableOptionSx, borderColor: "divider", borderRadius: Radius.M } as const;

type Props = {
  title: string;
  subtitle?: string;
  // the record's type, left of the title, e.g. a briefcase for an employment income
  icon?: ReactNode;
  onClick: () => void;
  children: ReactNode;
};

// A record that opens on a click, e.g. an asset, the whole card a button. The box draws the hover and the focus ring
// (selectableOptionSx reads the button's focus through :has), so the button drops its own grey wash.
export const Tile: FC<Props> = ({ title, subtitle, icon, onClick, children }) => (
  <Box sx={[tileSx, { overflow: "hidden" }]}>
    <CardActionArea onClick={onClick} sx={{ p: Spacing.XL, "& .MuiCardActionArea-focusHighlight": { display: "none" } }}>
      <Stack direction="row" spacing={Spacing.L} alignItems="flex-start">
        {icon}

        <Stack spacing={Spacing.M} minWidth={0} flex={1}>
          <Stack spacing={Spacing.XS}>
            <Typography variant="body2" fontWeight={600}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Stack>

          {children}
        </Stack>
      </Stack>
    </CardActionArea>
  </Box>
);
